import styled from 'styled-components';

const Description = styled.input`
  font-size: 16px;
  font-weight: 400;
  color: #edece8;
  background: transparent;
  border: 1px;
  border-radius: 5px;
  pointer-events: ${({ isEditable }) => (isEditable ? 'auto' : 'none')};
  padding: 3px 5px 3px;
  border-style: solid;
  border-color: ${({ isEditable }) => (isEditable ? '#58616d' : 'transparent')};
  outline: none;
  width: 85%;
  margin-top: 5px;
  opacity: 0.5;
  margin-bottom: 5px;
`;

export default Description;
